import React from 'react';

export default function AppLoader() {
  return <main className="app-loader" role="status" aria-live="polite" aria-busy="true">
    <img className="app-loader-logo" src={`${process.env.PUBLIC_URL || ''}/truckx-logo.webp`} alt="TruckX" width="488" height="173" />
    <div className="app-loader-dots" aria-hidden="true"><i /><i /><i /></div>
    <p>Loading dashboard...</p>
  </main>;
}
